import { CmsImageData, StaticPicture } from '@fcom/core-api/interfaces';
import { buildUrl, isTruthy } from '@fcom/core/utils';
import { aspectRatio } from '@fcom/ui-components/components/images/utils';
import { LQIP_WIDTH, THUMBNAIL_WIDTH } from '@fcom/ui-components/components/images/constants';
import { AspectRatios } from '@fcom/ui-components/components/images/enums';
import { ResponsiveImageData } from '@fcom/ui-components/components/images/interfaces';

import { getWidestImageWidth, isStaticPicture } from '../images.utils';
import { FALLBACK_WIDTH, IMAGE_WIDTHS } from '../../../interfaces';

export const BLACK_IMAGE_PLACEHOLDER = '#00000000';

export const isBlackImagePlaceholder = (lqip: string): boolean => lqip === BLACK_IMAGE_PLACEHOLDER;

export function mapToResponsiveImageWithCustomAspectRatio(
  pic: CmsImageData | StaticPicture,
  aspect: AspectRatios,
  maxWidth?: number
): ResponsiveImageData {
  if (isStaticPicture(pic)) {
    return {
      fallbackSrc: pic.fullSizeUrl,
      thumbnailSrc: pic.thumbnailSrc,
      lqipSrc: pic.thumbnailSrc,
      srcSet: [],
      hasAspectRatio: false,
    };
  }

  const images =
    aspect === AspectRatios.ORIGINAL
      ? { [FALLBACK_WIDTH]: buildUrl(pic.data, { impolicy: 'crop', width: pic.width, height: pic.height }) }
      : pic.responsiveImageLinksData[aspect];

  const imageLQIP = pic.responsiveImageLinksData['portrait_ratio1x1'];

  const widestWidth = getWidestImageWidth(images);

  const srcSet = (maxWidth ? IMAGE_WIDTHS.filter((width) => width <= maxWidth) : IMAGE_WIDTHS).map((width) => {
    return {
      width,
      src: buildUrl(images[widestWidth], { imwidth: width }),
    };
  });
  const disableCropping = isTruthy(pic.disableCropping) && !!pic.width && !!pic.height;

  const fallbackSrc = buildUrl(images[FALLBACK_WIDTH], { imwidth: FALLBACK_WIDTH });

  return {
    fallbackSrc: buildUrl(images[FALLBACK_WIDTH], { imwidth: FALLBACK_WIDTH }),
    thumbnailSrc: buildUrl(images[FALLBACK_WIDTH], { imwidth: THUMBNAIL_WIDTH }),
    lqipSrc: buildUrl(imageLQIP[FALLBACK_WIDTH], { imwidth: LQIP_WIDTH }),
    srcSet,
    hasAspectRatio: aspect === AspectRatios.ORIGINAL || disableCropping ? false : fallbackSrc.includes('impolicy=crop'),
    customAspectRatio: disableCropping ? aspectRatio(pic.width, pic.height) : undefined,
  };
}
